import { integrationMiddleware } from "../network/middlewareHttp";
import { baseURL } from "./FetchUrl";

class ProductsCatalog{
    apiURL = baseURL
    getEndpoint = '/api/Products/get'
    postEndpoint = '/api/Products/post'
    putEndpoint = '/api/Products/put'
    deleteEndpoint = '/api/Products/delete'
    http = integrationMiddleware(this.apiURL, 'AUTH TOKEN')

    getProductsList = async(filter) => {
        return new Promise(async(resolve, reject) => {
            this.http.get(this.apiURL + this.getEndpoint+ "?filter=" + (filter ? "true" : "false"))
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
    postProducts = async(body) => {
        return new Promise(async(resolve, reject) => {
            this.http.post(this.apiURL + this.postEndpoint, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    deleteProducts = async(id) => {
        return new Promise(async(resolve, reject) => {
            this.http.delete(this.apiURL + this.deleteEndpoint + '/' + id )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    updateProducts = async(id, body) => {
        return new Promise(async(resolve, reject) => {
            this.http.put(this.apiURL + this.putEndpoint + '/' + id, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default ProductsCatalog
